// extracted by mini-css-extract-plugin
module.exports = {"RightSidePanel":"RightSidePanel_RightSidePanel__2G7hC","mtMinus220":"RightSidePanel_mtMinus220__1VTKf"};